var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"RkmModal",attrs:{"buttons":['cancel', 'save'],"loading":_vm.loading,"large":"","title":"Anotações da enfermagem"},on:{"save":_vm.handleSave}},[_c('Form',{ref:"Form",attrs:{"data":_vm.data,"model":_vm.model},on:{"saved":_vm.saved}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }